const isDateValid = date => {
  if (date === null) {
    return false;
  }
  if (date instanceof Date) {
    return validDateObject(date);
  }
  return validDateString(date);
};
const validDateString = dateString => validDateObject(new Date(dateString));
const validDateObject = dateObject => !isNaN(dateObject.getTime());

export { isDateValid, validDateString };
//# sourceMappingURL=isDateValid.mjs.map
